import {
	Wrapper,
	ActionWrapper,
	ImageWrapper,
	WrapperRest,
} from './plans.styles';
import Loading from '@/common/components/Loading';
import usePlanHook from './hooks/usePlanHook';
import Timer from '../timer/Timer';
import SzeryfMobile from '../../images/szeryf-wstega_mobile.png';
import Plan from '../plan/Plan';
import Banner from '../banner/Banner';

const Plans = () => {
	const { isLoading, promo, selectedOption } = usePlanHook();

	return (
		<>
			{isLoading && <Loading />}
			<Wrapper style={{ height: 'fit-content' }}>
				<Timer promo={promo} />
				<Banner promo={promo} type={selectedOption?.type?.value} />
			</Wrapper>
			<WrapperRest>
				<Plan promo={promo} selectedOption={selectedOption} />
				<ActionWrapper>
					<div id='fsc-embedded-checkout-container' autoFocus></div>
				</ActionWrapper>
				<ImageWrapper>
					<img src={SzeryfMobile} />
				</ImageWrapper>
			</WrapperRest>
		</>
	);
};

export default Plans;
